import FootballStatsCategory from "../../stats/football-stats-category";
import FootballState from "../../state/football-state";
import StatsRule from "../../../common/stats-rule";

export default class LateralStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.Lateral &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const distance = gameContext.calculateDistance(fragment.receivedAt);
        const player = fragment.lateralTo;
        const resultedInTd =
            (gameContext.isVisitorPossession() && fragment.receivedAt <= 0) ||
            (gameContext.isHomePossession() &&
                fragment.receivedAt >= gameContext.getFieldLength());

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: player.teamId,
            playerId: player.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.LATERAL,
            values: {
                yards: distance,
                completed: 1,
                touchdowns: resultedInTd ? 1 : 0
            }
        });
    }
}
